class StickyCart extends HTMLElement {
    constructor() {
        super()
        this.isVisible = false;
        this.init();
    }

    setVariables() {
        this.form = this.querySelector('.product-form');
        this.variants = this.querySelector('sticky-variant-selects');
        this.btnSubmit = this.form.querySelector('.product-form__buttons-wrapper');
        this.btnSelectVariants = this.form.querySelector('.product-form__select');
    }

    // --- ANIMATIONS --- //
    setVisibility() {
        const defaultForm = document.querySelector('.product-form-wrapper');
        const observer = new IntersectionObserver((entries) => {
            const { boundingClientRect, isIntersecting } = entries[0];
            if(window.scrollY > boundingClientRect.top){
                this.classList.toggle('is-open', !isIntersecting)
                this.isVisible = !isIntersecting

                if(!this.isMobile()) this.style.top = '0'
                else this.style.top = 'auto'

                this.ourEvents()
            }
        }, {
            threshold: 1
        })

        defaultForm && observer.observe(defaultForm)
    }

    setTop() {
        const elemToObserve = document.querySelector('#shopify-section-header');
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if(mutation.attributeName == "class"){
                    const currentClassState = mutation.target.classList.contains('shopify-section-header-hidden');
                    if (!this.classList.contains('is-open')) return

                    if(!this.isMobile()) currentClassState ? this.style.top = '0' : this.style.top = `${mutation.target.clientHeight}px`
                    else this.style.top = 'auto'
                }
            })
        })

        elemToObserve && observer.observe(elemToObserve, {attributes: true});
    }
    // --- END ANIMATIONS --- //

    ourEvents() {
        this.isVisible ? document.dispatchEvent(new Event('stickyCart::open')) : document.dispatchEvent(new Event('stickyCart::close'))
    }

    isMobile() {
        return window.innerWidth < 768 ? true : false
    }

    // --- EVENT HANDLERS --- //
    formError() {
        setTimeout(() => this.form.handleErrorMessage(), 4000)
    }

    formNotifyMe(evt) {
        if(!evt.target.closest('.product-form__submit--notify')) return
        evt.preventDefault()
        evt.stopImmediatePropagation();

        const appNotifyMe = document.querySelector(`#restock-${this.dataset.handle}`);
        appNotifyMe && appNotifyMe.click()
    }

    elemSelectVariants(evt) {
        evt.preventDefault()
        evt.stopPropagation()

        this.variants.classList.add('is-open')
        this.btnSelectVariants.style.display = 'none'
        this.btnSubmit.style.display = 'block'
    }
    // --- END EVENT HANDLERS --- //

    setListeners() {
        this.form.addEventListener('submit', () => this.formError())
        document.addEventListener('click', (evt) => this.formNotifyMe(evt))
        if(this.variants && this.isMobile()) {
            this.btnSelectVariants.addEventListener('click', (evt) => this.elemSelectVariants(evt))
        }

        window.addEventListener('resize', () => {
            // REMOVE ALL EVENT LISTENER AFTER RESIZE.
            this.form.removeEventListener('submit', () => this.formError())
            document.removeEventListener('click', (evt) => this.formNotifyMe(evt))
            if(this.variants && this.isMobile()) {
                this.btnSelectVariants.removeEventListener('click', (evt) => this.elemSelectVariants(evt))
            }

            // REINIT OUR FUNCTION AFTER REMOVE ALL EVENT LISTENER
            this.init()
        })
    }

    init() {
        this.setVariables()
        this.setVisibility()
        !this.isMobile() && this.setTop()
        this.setListeners()
    }
}

customElements.define('sticky-cart', StickyCart)

class StickyVariantSelects extends VariantSelects { // This CustomElement is extended from 'global.js / line 746'
    constructor() {
        super()
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.renderProductInfo();

        !this.currentVariant
            ? this.setUnavailable()
            : this.updateVariantInput();
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}`);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    async renderProductInfo() {
        const req = await fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        const responseText = await req.text()

        if(req.status !== 200) return

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const priceDestination = document.getElementById(`price-${this.dataset.section}`);
        const imageDestination = document.getElementById(`image-${this.dataset.section}`);
        const buttonDestination = document.getElementById(`submit-${this.dataset.section}`);
        const priceSource = html.getElementById(`price-${this.dataset.section}`);
        const imageSource = html.getElementById(`image-${this.dataset.section}`);
        const buttonSource = html.getElementById(`submit-${this.dataset.section}`);

        if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;
        if (imageSource && imageDestination) imageDestination.innerHTML = imageSource.innerHTML;
        if (buttonSource && buttonDestination) buttonDestination.innerHTML = buttonSource.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
    }
}

customElements.define('sticky-variant-selects', StickyVariantSelects);
